import React, { useEffect, useState } from 'react';
import { BellRing, BellOff } from 'lucide-react';
import { toast } from 'sonner';
import { pushSupported, getExistingSubscription, enablePush, disablePush } from '../../lib/push';

export function PushToggle() {
  const [state, setState] = useState('checking');

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!pushSupported()) { if (alive) setState('unsupported'); return; }
      try {
        const sub = await getExistingSubscription();
        if (alive) setState(sub ? 'enabled' : 'off');
      } catch {
        if (alive) setState('off');
      }
    })();
    return () => { alive = false; };
  }, []);

  if (state === 'unsupported' || state === 'checking') return null;

  const enable = async () => {
    if (Notification.permission === 'denied') {
      toast.error('Push is blocked — enable notifications for this site in your browser settings.');
      return;
    }
    try {
      await enablePush();
      setState('enabled');
      toast.success('Push notifications enabled');
    } catch (e) {
      toast.error(e?.message || 'Could not enable push notifications');
    }
  };

  const disable = async () => {
    try {
      await disablePush();
      setState('off');
      toast.success('Push notifications disabled');
    } catch {
      toast.error('Could not disable push notifications');
    }
  };

  if (state === 'enabled') {
    return (
      <button data-testid="push-disable-btn" onClick={disable} className="flex items-center gap-1 text-xs text-kelate-soft hover:text-kelate-ink">
        <BellOff size={12} /> Push on
      </button>
    );
  }
  return (
    <button data-testid="push-enable-btn" onClick={enable} className="flex items-center gap-1 text-xs font-medium text-kelate-wood hover:text-kelate-darkwood">
      <BellRing size={12} /> Enable push
    </button>
  );
}
